import { createContext, useContext } from 'react';

export const FormContext = createContext(null);

type Dispatch<V> = (val: V) => void;

type FormValue<V> = [
    V,
    Dispatch<V>,
];

export function useFormValue <T, K extends keyof T> (field: K): FormValue<T[K]> {
    const { state, dispatch } = useContext(FormContext) as {
        state: T,
        dispatch: Dispatch<{
            field: K,
            value: T[K]
        }>,
    };

    return [
        state[field],
        (value: any) => {
            dispatch({ field, value });
        },
    ];
};
